// extracted by mini-css-extract-plugin
export default {"reviews-header":"_gbikdl","reviewsHeader":"_gbikdl","review-removed":"_4majv9","reviewRemoved":"_4majv9"};